import type { NUsers, NFiles } from '@app/types';

export namespace NActionsHistory {
  export type ModelActionHistory = {
    Timestamp: string;
    ActionId: string | null;
    ActionUserId: number;
    ObjectId: number;
    Icon: string | null;
    ActionUser: string | null;
    ObjectType: string | null;
    ObjectS: string | null;
    ActionText: string | null;
    IsImportantAction: boolean;
    ActionItems: ModelActionHistoryItem[] | null;
    Files: NFiles.ModelClientFile[] | null;
    ChatMessages: ModelActionChatMessage[] | null;
    IdS: string;
  };

  export type ModelActionChatMessage = {
    MessageId: number;
    Type: string | null;
    Timestamp: string;
    ClientId: number;
    UserId: number;
    BranchId: number;
    BranchName: string | null;
    UserFirstName: string | null;
    UserLastName: string | null;
    UserPhoto: string | null;
    SocialIntegrationId: number;
    Direction: 'in' | 'out' | null;
    Status: string | null;
    ErrorMessage?: string | null;
    Message: string | null;
    File: NFiles.ModelClientFile | null;
    FileId: number;
    WasEdited: boolean;
    ReactionEmojiOwn: string | null;
    ReactionEmojiCompanion: string | null;
    LocationLatLon: string | null;
    LocationAddress: string | null;
    LocationName: string | null;
    ReplyClientMessageId: number | null;
    ReplyClientMessage: string | null;
    IsForwarded: boolean;
    SenderAccountLogin: string | null;
    ReceiverAccountLogin: string | null;
    SocialIntegrationName: string | null;
    SocialType: string | null;
    SocialTypeUserFriendly: string | null;
    IsFromOutside: boolean;
  };

  export type ModelActionHistoryItem = {
    Icon: string | null;
    ValueNew: string | null;
    ValueOld: string | null;
    Property: string | null;
  };

  export type Action = {
    ActionId: string | null;
    ActionItems: ModelActionHistoryItem[] | null;
    ActionText: string | null;
    ActionUser: string | null;
    ActionUserId: number;
    Icon: string | null;
    ObjectId: number;
    ObjectS: string | null;
    Timestamp: string;
    IsImportantAction: boolean;
    ObjectType: string | null;
    key?: string;
  };

  export type UserHistoryFilterData = {
    Keys: string[];
    Users: NUsers.UserForActionsHistory[];
  };

  export type ModelSearchUserHistoryFilter = {
    Keys: UserHistoryFilterData['Keys'] | null;
    UserIds: Array<NUsers.User['id']> | null;
    DateStart: string | null;
    DateEnd: string | null;
    ItemsPerPage: number;
    IsOnlyImportant: boolean;
  };

  export type ModelSearchUserHistoryResult = {
    Id: number;
    Filter: ModelSearchUserHistoryFilter;
    UserChanges: NActionsHistory.Action[] | null;
    PageN: number;
    CountPages: number;
    CountUserChanges: number;
  };
}
